import { render, staticRenderFns } from "./LayoutSquared.vue?vue&type=template&id=e31ce9e4&scoped=true&"
import script from "./LayoutSquared.vue?vue&type=script&lang=js&"
export * from "./LayoutSquared.vue?vue&type=script&lang=js&"
import style0 from "./LayoutSquared.vue?vue&type=style&index=0&id=e31ce9e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e31ce9e4",
  null
  
)

export default component.exports